














































import { ObjectFactory } from '@/config/objectFactory';
import { MemberProfile } from '@/types/response';
import { MathUtils } from '@/util/mathUtils';
import { Component, Vue } from 'vue-property-decorator';
import ChangePaymentModal from './ChangePaymentModal.vue';
import AddPaymentModal from './AddPaymentModal.vue';
import { ApiRequest, ChargeMultipleInvoicesRequest } from '@/types/request';
import { MedTransGoConstants } from '@/util/constants';
import { EventBus } from '@/main';
import { ToastEvent } from '@/types/event';
import { CommonUtils } from '@/util/commonUtils';
import { Invoice, Particular, RideCreditMethod } from '@/types/entity';

@Component({
    components: {
        ChangePaymentModal,
        AddPaymentModal,
    },
    props: {
        selectedInvoices: Array,
        monthlyInvoiceId: String,
    },
    data() {
        return {
            creditPointAmountInUSD: null,
        };
    },
})
export default class PayInvoicesModal extends Vue {
    private show = true;
    private perUnitAmount = '';
    private customerPaymentId = '';
    private memberProfile: MemberProfile = ObjectFactory.getCacheService().getMemberInfo();
    private paymentCustomerId: string = '';
    private paymentCustomer: any = '';
    private showAddPaymentForm = false;
    private showChangePaymentForm = false;
    private errorMessage = '';
    private rideCreditMethod: RideCreditMethod = null as any;
    private perCreditPrice: number = null as any;
    private totalCreditAmount = 0;
    private orgId = '';
    private totalAmountInUSD = '';
    private totalAmountInCents = 0;

    public async mounted() {
        this.getTotalAmount();
        const organization = await ObjectFactory.getOrganizationService().
            getOrgDetailsById(this.$store.state.serverUrl);
        if (organization && organization.data && organization.data.rideCreditMethod && organization.data.id) {
            this.orgId = organization.data.id;
            this.rideCreditMethod = organization.data.rideCreditMethod;
        }
        if (organization.data &&
            (!organization.data.chequePaymentRequest || organization.data.chequePaymentRequest.status !== 'Approved')) {
            this.getPaymentCustomer();
        }
        await this.getPaymentCustomer();
        if (this.totalAmountInCents === 0) {
            this.payInvoiceAmount();
        }
    }
    private close() {
        this.totalAmountInCents = 0;
        this.totalAmountInUSD = '';
        this.$emit('close');
        this.show = false;
    }

    private async getPaymentCustomer() {
        if (!this.customerPaymentId) {
            const memberResponse = await ObjectFactory.getMemberService().
                getMemberDetails(this.$store.state.serverUrl, this.memberProfile.memberId);
            if (memberResponse.success && memberResponse.data && memberResponse.data.paymentCustomerId) {
                this.customerPaymentId = memberResponse.data.paymentCustomerId;
                this.paymentCustomerId = memberResponse.data.paymentCustomerId;
            } else {
                this.paymentCustomer = '';
                return;
            }
        }
        const response = await ObjectFactory.getPaymentSourceService()
            .getPaymentCustomer(this.$store.state.serverUrl, this.customerPaymentId);
        this.paymentCustomer = response.data;
    }

    private async payInvoiceAmount() {
        const invoiceIds = this.$props.selectedInvoices.map((invoice: Invoice) => invoice.invoiceId);
        const iHttpService = ObjectFactory.getHttpService();
        const chargeInvoicesrequest: ChargeMultipleInvoicesRequest = {
            totalAmountInCents: this.totalAmountInCents,
            paymentCustomer: this.paymentCustomer.defaultSource.id,
            invoiceIds,
            monthlyInvoiceId: this.$props.monthlyInvoiceId,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_INVOICE}/chargeConsolidated`,
            data: chargeInvoicesrequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<any>(apiRequest);
        if (response.success) {
            this.errorMessage = '';
            this.$emit('success');
            const toastEvent: ToastEvent = {
                message: 'Invoice Paid successfully.',
                title: 'Success',
                varient: 'success',
                timeout: 15000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
            this.$props.selectedInvoices = [];
        } else if (response.errors) {
            this.errorMessage = this.errorMessage = CommonUtils.translateErrorCode(response.errorCode);
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateErrorCode(response.errorCode),
                title: 'Error',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            if (response.errorCode && response.errorCode === 'INVOICES_NOT_FOUND') {
                this.close();
            }
        }
    }

    private getTotalAmount() {
        this.totalAmountInCents = 0;
        const invoicesData: Invoice[] = this.$props.selectedInvoices;
        invoicesData.forEach((invoice: Invoice) => {
            this.totalAmountInCents += MathUtils.calculateTotal(invoice.particulars);
        });
        this.totalAmountInUSD = MathUtils.formatCurrency(this.totalAmountInCents);
    }

}
